
import { Component, ElementRef, ViewChild } from '@angular/core';
import { PCESEmailPendingLists } from '../models/PCES-email-pending-lists.model';
import { NgZone } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { map, catchError, filter } from 'rxjs/operators';
import { of } from 'rxjs';
import { GridApi, IServerSideDatasource, IServerSideGetRowsParams,  ICellRendererParams, ColDef} from 'ag-grid-community';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { AgGridAngular } from 'ag-grid-angular';
import { FormBuilder, FormGroup } from '@angular/forms';
//import { PcesDetailsComponent } from '../pces-client-lists/pces-client-details/pces-details.component';
import { PCESModalComponent } from '../pces-client-lists/pces-lists-modal/pces-lists-modal.component';
import { PCESClientCreatorComponent } from '../pces-client-lists/pces-client-creator/pces-client-creator.component';

@Component({
  selector: 'app-pces-client-lists',
  templateUrl: './pces-email-pending-lists.component.html',
  styleUrls: ['./pces-email-pending-lists.component.scss']
})

// PCES Client List Component
export class PcesEmailPendingListsComponent {

  // Assign Client details component to be the detail cell rendered
  //public detailCellRenderer: any = PcesDetailsComponent;  

  rowData: PCESEmailPendingLists[] = [];
  
  @ViewChild('agGrid', { static: false }) agGrid!: AgGridAngular;

  constructor(private http: HttpClient, private fb: FormBuilder, private route: ActivatedRoute, private router: Router, private dialog: MatDialog, private zone: NgZone) { }

  search_client: FormGroup = this.fb.group({
    clientname: [''],
    factoringfor: [''],
  })

  private apiUrl = '/api/pces_lists/pces_email_pending_lists.php';

  // variable to store universal filter 
  universalFilter = ''

  // default column definitions
  defaultColDef = {
    sortable: true,
    filter: 'agTextColumnFilter',
    filterParams: {
      caseSensitive: false,
    },
    autoHeight: true,
    cellClass: 'cell-wrap-text',
    resizable: true,
    editable: true
  };

  // define headers for the main Client list grid
  columnDefs: ColDef[] = [
    { field: 'pces_outgoing_email_uuid', headerName: 'UUID', hide: true},
    {
      headerName: 'Client Name',
      field: 'contact_organization',
      cellStyle: {'font-weight': 'bold'},          
      //cellRenderer: 'agGroupCellRenderer',    // Add Drop Down Detail
      width: 400
    },
    {
      headerName: 'Email', field: 'contact_email',
      width: 350
    },
    { headerName: 'Cheque No', field: 'cheque_no', width: 150 },        
    { headerName: 'Total Amount', field: 'total_amount', width: 150 },      
    {
      headerName: 'Status',
      field: 'status',
      cellRenderer: statusTypeFormatting,       
      width: 200
    },  
    {
      headerName: 'Action', cellRenderer: (params: any) => {
        const button = document.createElement('button');
        const icon = document.createElement('i');

        // Add Font Awesome classes to the icon element
        icon.classList.add('fas', 'fa-trash'); 

        // Append the icon to the button
        button.appendChild(icon);
        button.addEventListener('click', () => {
          this.zone.run(() => {
            this.deletePendingEmail(params);
          });
        });
        return button;
      }, editable: false, width: 100,
    },      
    {
      headerName: 'Action', cellRenderer: (params: any) => {
        const button = document.createElement('button');
        const icon = document.createElement('i');

        // Add Font Awesome classes to the icon element
        icon.classList.add('fas', 'fa-envelope'); 

        // Append the icon to the button
        button.appendChild(icon);
        button.addEventListener('click', () => {
          this.zone.run(() => {
            this.sendEmail(params);
          });
        });
        return button;
      }, editable: false, width: 100,
    },                               
  ]

  
  //Apply filter dynmically
  ngAfterViewInit() {
    console.log('ngAfterViewInit:')
    if (this.agGrid) {
      this.route.queryParamMap.subscribe((params) => {
        const clientname = params.get('clientname');
        const contact_email = params.get('contact_email');
        
        if (clientname) {
          this.applyClientName(clientname);
          console.log('clientname:',clientname)
        }
        else if (contact_email) {
          this.applyEmail(contact_email);
          console.log('contact_email:',contact_email)
        }
        else {
          this.agGrid.api.setFilterModel({});
        }
      });
    }
  }


  //Apply filter for ClientName
  applyClientName(filterText: string) {
    if (this.agGrid) {
      this.agGrid.api.setFilterModel({
        clientname: {
          filterType: "text",
          type: "Contains",
          filter: filterText,
        },
      });
      this.agGrid.api?.onFilterChanged();
    }
  }  

  //Apply filter for Email
  applyEmail(filterText: string) {
    if (this.agGrid) {
      this.agGrid.api.setFilterModel({
        contact_email: {
          filterType: "text",
          type: "Contains",
          filter: filterText,
        },
      });
      this.agGrid.api?.onFilterChanged();
    }
  }  

  search() {
    const clientname = this.search_client.get('clientname')?.value
    const contact_email = this.search_client.get('contact_email')?.value
    if (clientname) {
      this.router.navigate(['/pces_client_lists'], { queryParams: { clientname: clientname } });
    }
    else if (contact_email) {
      this.router.navigate(['/pces_client_lists'], { queryParams: { contact_email: contact_email } });
    }
    else {
      console.log('Invalid search data.')
    }    
  }

  //Reset the filter by setting to empty object
  resetFilter() {
    this.router.navigate(['/pces_client_lists']);
    this.search_client.get('clientname')?.setValue('');
    this.search_client.get('contact_email')?.setValue('');
  }  

  private gridApi!: GridApi;

  onGridReady(params: any) {
    this.gridApi = params.api
    params.api.setServerSideDatasource(this.getServerSideDatasource());
    this.gridApi = params.api; 
  }


  getServerSideDatasource(): IServerSideDatasource {
    return {
      getRows: (params: IServerSideGetRowsParams) => {
        this.getPcesList(params.request.startRow, params.request.endRow, params.request.filterModel, params.request.sortModel)
          .subscribe(
            response => {
              if (response) {
                console.log(response);
                params.success({ rowData: response.rowData, rowCount: response.rowCount });
              } else {
                params.fail();
              }
            },
            error => {
              console.log(error);
              params.fail();
            }
          );
      }
    };
  }

  getPcesList(startRow: number = 0, endRow: number = 0, filterModel: any = {}, sortModel: any = []) {
    const urlApi = this.apiUrl;

    const filters = Object.entries(filterModel).map(([column, filter]: [string, any]) => {
      console.log('Filter model:', filterModel);
      console.log('Filter', filter)

      let operator = '';
      let value = '';

      if (filter.filterType === 'text') {
        operator = filter.type;
        value = filter.filter;
      } else if (filter.filterType === 'set') {
        operator = 'equals'; // Or any other appropriate operator for set filter
        value = filter.values.join(','); // Join selected values with a delimiter if needed
      }

      return {
        column,
        operator,
        value,
      };
    });

    const params: any = {
      startRow: startRow,
      endRow: endRow,
      sortModel: JSON.stringify(sortModel),
      filters: JSON.stringify(filters),
    };

    console.log('an array of filter object: ', filters)
    const url = `${urlApi}?startRow=${startRow}&endRow=${endRow}&universalFilter=${this.universalFilter}`;

    return this.http.get<any>(url, { params }).pipe(
      map((response) => {
        return {
          rowData: response.data,
          rowCount: response.total,
        };
      }),
      catchError((error) => {
        console.log(error);
        return of(null);
      }),
      filter(response => response !== null)
    );

  }  

  deletePendingEmail(params: any) {
    const dialogConfig = new MatDialogConfig();
    const pces_outgoing_email_uuid = params.data.pces_outgoing_email_uuid;
    const clientname = params.data.contact_organization;

    dialogConfig.width = '10px'; // You can use pixels or other units
    dialogConfig.height = '10px';
    dialogConfig.data = {
      data: {
        modalTitle: 'Delete Pending Email',
        modalMessage: {uuid: params.data.pces_outgoing_email_uuid, client_name: params.data.contact_organization},
      },
    };

    console.log('Dialog Config:', dialogConfig);

    this.dialog.open(PCESModalComponent, dialogConfig);
  }

  deleteAllPendingEmail() {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.width = '10px'; // You can use pixels or other units
    dialogConfig.height = '10px';
    dialogConfig.data = {
      data: {
        modalTitle: 'Delete All Pending Email',
        modalMessage: {},
      },
    };

    console.log('Dialog Config:', dialogConfig);

    this.dialog.open(PCESModalComponent, dialogConfig);
  }

  sendEmail(params: any) {
    const dialogConfig = new MatDialogConfig();
    const pces_outgoing_email_uuid = params.data.pces_outgoing_email_uuid;
    const clientname = params.data.contact_organization;

    dialogConfig.width = '10px'; // You can use pixels or other units
    dialogConfig.height = '10px';
    dialogConfig.data = {
      data: {
        modalTitle: 'Send Email',
        modalMessage: {uuid: params.data.pces_outgoing_email_uuid, client_name: params.data.contact_organization},
      },
    };

    console.log('Dialog Config:', dialogConfig);

    this.dialog.open(PCESModalComponent, dialogConfig);
  }
  
  sendAllEmail() {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.width = '10px'; // You can use pixels or other units
    dialogConfig.height = '10px';
    dialogConfig.data = {
      data: {
        modalTitle: 'Send ALL Email',
        modalMessage: {},
      },
    };

    console.log('Dialog Config:', dialogConfig);

    this.dialog.open(PCESModalComponent, dialogConfig);
  }

  pcesEmailLists() {
    this.router.navigate(['/pces_email_lists']);
  }

}



// function for custom cell renderer for shipment types (colored)
function statusTypeFormatting(params: ICellRendererParams) {
  let statusTypes: string[] = []
  if (params.value != null) {
    statusTypes = params.value.split(",");
  }
  let buttonsHtml = '';

  for (let type of statusTypes) {
    let trimmedType = type.trim();
    let bgColor = '';

    switch (trimmedType) {
      case 'PENDING':
          bgColor = '#00FF00';
          break;         
      case 'CONTACT NOT FOUND':
        bgColor = '#FF0000';
        break;
      case 'EMAIL NOT FOUND':
          bgColor = '#FA7878';
          break;       
      default:
        bgColor = '#FFFFFF';
    }

    buttonsHtml += '<button class="btn dropdown-toggle button-text-wrapper" style="background-color:' + bgColor + ';border-radius:10px;font-weight:bold;">' + trimmedType + '</button> <br>';
  }

  let element = '<div class="btn-group">' + buttonsHtml + '</div>';

  return element;
}
